export const ACCOUNT_STATEMENT = gql`
    query GetAccountStatement($statementId: Int!) {
        getAccountStatement(statementId: $statementId) {
            id
            accountStatementId
            startDateTime
            endDateTime
            statementDate
            createdAt
            outstandingBalance
            balanceBroughtForward
            totalInvoiceAmount
            totalCreditApplied
            totalPaymentsMade
            merchant {
                tradingName
                accountNumber
                contactName
                contactNumber
                billingAddress
                email
                Partner {
                    countryDetails {
                        currencies {
                            symbol
                        }
                    }
                }
            }
            accountStatementItems {
                id
                transactionDate
                description
                credit
                debit
                sageInvoiceNumber
                sageCreditNoteNumber
                paymentMethod
                paymentId
                accountStatementId
                itemType
                rollingBalance
                createdAt
            }
        }
    }
`;

export const GET_ACCOUNT_STATEMENT_PDF = gql`
    query GetAccountStatementPDF($statementId: Int!) {
        getAccountStatementPDF(statementId: $statementId) {
            downloadLink
            createdAt
        }
    }
`;
